<div class="under-construction-container">
  <div class="content">
    <div class="icon-wrapper">
      <i class="fa-solid fa-person-digging"></i>
    </div>
    <h1 class="title">الصفحة تحت الإنشاء</h1>
    <p class="subtitle">
      نحن نعمل بجد لإطلاق هذه الصفحة قريباً. يرجى التحقق مرة أخرى لاحقاً.
    </p>
    <a routerLink="/home" class="btn-home">العودة للرئيسية</a>
  </div>
</div>